import { useEffect, useState } from "react";

/** MUI */
import { Alert, Box, Grid, IconButton } from "@mui/material";
/** - icons */
import { SmsFailedOutlined } from "@mui/icons-material";

/** redux */
import { getPrediction } from "@/src/_appStore/DB_Common";
import { useSelector } from "react-redux";

/** UI */
import AppTooltip from "@/src/_common/AppTooltip";

const Predictionist = (props) => {
    const { JTS_NEW, tableOrChart, onPredictionData } = props;

    /** states */
    const [SHOW_TOOLTIP, setSHOW_TOOLTIP] = useState(false);
    /** - redux */
    const prediction = useSelector(getPrediction);

    /** Effects */
    useEffect(() => {
        if (!JTS_NEW?.length) {
            return;
        }
        // setLOADING_JTS(false);

        const _data = {
            ...prediction[tableOrChart]?.PREDICTION_DATA,
            jts: JTS_NEW,
        };

        onPredictionData &&
            JSON.stringify(_data) !== JSON.stringify(prediction[tableOrChart]?.PREDICTION_DATA) &&
            onPredictionData(_data);
    }, [JTS_NEW, prediction]);

    return (
        <>
            {!!prediction?.table?._errMessageShort && (
                <Grid item xs={12} sx={{position:'relative'}}>
                    <Alert
                        severity={"error"}
                        sx={{ mb: 4, position:'absolute', zIndex:13, width:'100%', minHeight:84 }}
                        // action={
                        //     <AppTooltip
                        //         title={
                        //             <div
                        //                 dangerouslySetInnerHTML={{
                        //                     __html: prediction?.table?._errMessage,
                        //                 }}
                        //             />
                        //         }
                        //         arrow
                        //         placement={"bottom-end"}
                        //         type={"light"}
                        //         open={SHOW_TOOLTIP}
                        //         onOpen={() => setSHOW_TOOLTIP(true)}
                        //         onClose={() => setSHOW_TOOLTIP(false)}
                        //     >
                        //         <IconButton
                        //             size={"small"}
                        //             sx={{ mt: -0.25, mr: 1 }}
                        //             onClick={() => setSHOW_TOOLTIP(true)}
                        //         >
                        //             <SmsFailedOutlined fontSize={"small"} color={"error"} />
                        //         </IconButton>
                        //     </AppTooltip>
                        // }
                    >
                        <Box component={"span"} sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                            {prediction?.table?._errMessageShort}
                        </Box>
                    </Alert>
                </Grid>
            )}
        </>
    );
};

export default Predictionist;
